import { TOOL_NAMES } from 'js/src/agent/toolNames';
import { z } from 'zod';

import type { ToolExecutionContext } from '../types';
import { VideoStateTool } from './VideoStateTool';

export const setMusicVolumeSchema = z.object({
    volume: z
        .number()
        .min(0)
        .max(100)
        .describe('Volume level from 0 (silent) to 100 (full volume)'),
});
export type SetMusicVolumeArgs = z.infer<typeof setMusicVolumeSchema>;

export class SetMusicVolumeTool extends VideoStateTool<typeof setMusicVolumeSchema> {
    protected override readonly schema = setMusicVolumeSchema;
    protected override readonly toolName = TOOL_NAMES.setMusicVolume;
    protected override readonly toolDescription =
        'Set the music volume for the video or a specific scene group (e.g. lower it when the music competes with a voiceover).';

    public override getToolDisplayName(): string {
        return 'Setting music volume';
    }

    public get statusIcon(): string {
        return 'volume_up';
    }

    public async execute(args: SetMusicVolumeArgs, context: ToolExecutionContext) {
        const { volume } = args;

        if (!this._luminary.musicAsset) {
            return `Error: No music is currently applied to the video. Please set music first using the ${TOOL_NAMES.setMusic} tool.`;
        }

        try {
            this._luminary.musicAsset.volume = volume;
            return `Successfully set global music volume to ${volume}%.`;
        } catch (error) {
            const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
            return `Error setting music volume: ${errorMessage}`;
        }
    }
}
